import { documentationActions } from '../../actions/constant';

const {
  SUCCESS_GET_SUBMISSION_DOCUMENT,
  FAILURE_GET_SUBMISSION_DOCUMENT,
  LOADING_GET_SUBMISSION_DOCUMENT,
  RESET_GET_SUBMISSION_DOCUMENT,
} = documentationActions;

const intitialstate: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const getSubmissionDocumentReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_SUBMISSION_DOCUMENT:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: true,
      };

    case FAILURE_GET_SUBMISSION_DOCUMENT:
      return {
        ...state,
        response: null,
        loading: false,
        isSuccess: false,
      };

    case LOADING_GET_SUBMISSION_DOCUMENT:
      return {
        ...state,
        loading: true,
      };

    case RESET_GET_SUBMISSION_DOCUMENT:
      return intitialstate;

    default:
      return state;
  }
};
